import React, {useEffect, useState} from "react";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import PopupDialog from "../component/PopupDialog";
import {
    getCustomerPermissionList,
    getSystemPermissionList,
    setCustomerParkingList,
    setCustomerPermissionList
} from "../httpUtils";
import {Checkbox, FormControlLabel} from "@material-ui/core";

export default function EditCustomerDialogPermission(props) {
    const [ currentId, setCurrentId ] = useState(undefined);
    const [ customerPermission, setCustomerPermission ] = useState([]);
    const [ permission, setPermission ] = useState([]);

    const [ isSaving, setSaving ] = useState(false);

    const _checkPermission = (id) =>{
        return customerPermission.find((v) => v === id) !== undefined
    }

    const _setPermission = (id, exist) => {
        if (exist) {
            if (!_checkPermission(id)) {
                setCustomerPermission([...customerPermission, id])
            }
        } else {
            const tmp = [...customerPermission];
            tmp.splice(customerPermission.findIndex((v)=>v==id), 1);
            setCustomerPermission(tmp);
        }
    }

    const _savePermission = (userId, permission) =>{
        setSaving(true);
        console.log(userId, permission)
        setCustomerPermissionList(userId, permission).then((v)=>{
            setSaving(false);
        }).catch((e)=>{
            setSaving(false);
        })
    }

    useEffect(()=>{
        if (currentId > 0) {
            getCustomerPermissionList(currentId).then((v)=>{
                setCustomerPermission(v)
            })
            getSystemPermissionList().then((v)=>{
                setPermission(v)
            })
        }
    }, [currentId]);

    useEffect(()=>{
        setCurrentId(props.id)
    }, [props.id])

    return (


            <Grid container spacing={1}>
                {
                    permission.map((v, i)=> (
                        <Grid item lg={12} md={12} sm={12} xl={12} xs={12} key={`pg-${i}`}>
                            <FormControlLabel
                                style={{marginBottom: 0}}
                                control={
                                    <Checkbox
                                        style={{marginBottom: 0}}
                                        checked={_checkPermission(v.id)}
                                        onChange={(e)=>{
                                            _setPermission(v.id, e.target.checked)
                                        }}
                                        color="primary"
                                        disabled={isSaving}
                                    />
                                }
                                label={v.name}
                            />
                        </Grid>
                    ))
                }

                <Grid item lg={12} md={12} sm={12} xl={12} xs={12}>
                    <Button onClick={_savePermission.bind(null, currentId, customerPermission)} color="primary" fullWidth disabled={isSaving}>
                        Сохранить
                    </Button>
                </Grid>

            </Grid>


    )
}
